import TextInput from "../../../components/TextInput/TextInput";

const SuperAdminProfileFields = ({ formData, errors, onChange }) => (
  <>
    <div className="main2_profileform_container_section_input">
      <TextInput
        title="Name"
        type="text"
        name="name"
        value={formData.name}
        onChange={onChange}
        placeholder="Enter your Name"
      />
      <span className="error">{errors.name}</span>
    </div>
    <div className="main2_profileform_container_section_input">
      <TextInput
        title="User Name"
        type="text"
        name="userName"
        value={formData.userName}
        onChange={onChange}
        placeholder="Enter your User Name"
        disabled
      />
      <span className="error">{errors.userName}</span>
    </div>
    <div className="main2_profileform_container_section_input">
      <TextInput
        title="Email ID"
        type="email"
        name="email"
        value={formData.email}
        onChange={onChange}
        placeholder="Enter your Email"
      />
      <span className="error">{errors.email}</span>
    </div>
  </>
);

export default SuperAdminProfileFields;
